import React from 'react';
import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import FileInput from '../../../components/common/FileInput';
import eDocumentPdfIcon from '../../../asset/img/edocument_pdf_icon.svg';
import orangeProfileIcon from '../../../asset/img/common/profile_orange_icon.svg';
import ProgressBar from '../../../components/common/ProgressBar';

// 파일 아이템 컴포넌트
const FileItem = ({ file, uploadProgress }) => (
  <div className="uploadFileBox">
    <img src={eDocumentPdfIcon} alt="pdf" />
    <div style={{ flex: 1 }}>
      <Typography variant="body2Medium">{file.htmDisplayNm}</Typography>
      {file.status === '1' && (
        <Typography variant="body2Medium" color="GrayScale-600">
          {file.htmRegDate}
        </Typography>
      )}
      {file.status === 'error' && (
        <Typography variant="body2Medium" color="Error-600">
          {file.errorMessage}
        </Typography>
      )}
      {file.status == '0' && <ProgressBar progress={uploadProgress[file.fileId] || 0} />}
    </div>
  </div>
);

// 파일 업로드 섹션 컴포넌트
const FileUploadSection = ({
  title,
  fileRef,
  fileList,
  htmDocType,
  multiple = false,
  onUpload,
  t,
  uploadProgress,
  notAllFile,
}) => {
  const filteredFiles = fileList.filter(file => file.htmDocType === htmDocType);

  return (
    <div className="displayFlexColumn" style={{ gap: '10px' }}>
      <div className="uploadFileTitle">
        <Typography variant="body1Bold">{title}</Typography>
        <Button
          color="secondary"
          size="small"
          onClick={() => fileRef.current.click()}
          value={t('uploadPdf.button')}
        />
        <FileInput
          multiple={multiple}
          fileRef={fileRef}
          fileHandler={e => onUpload(e.target.files)}
          accept=".pdf"
        />
      </div>
      {notAllFile && htmDocType === 'D' && (
        <div className="uploadNotAllFile">
          <img src={orangeProfileIcon} alt="profile" />
          <Typography variant="body2Medium">{t('uploadPdf.notAllFile')}</Typography>
        </div>
      )}
      {fileList.length > 0 && filteredFiles.length > 0 && (
        <div className="uploadFileBoxContainer">
          {filteredFiles.map(file => (
            <FileItem
              key={file.fileId || file.htmDisplayNm}
              file={file}
              uploadProgress={uploadProgress}
            />
          ))}
        </div>
      )}
      {(fileList.length === 0 || filteredFiles.length === 0) && (
        <div className="uploadFileBoxContainer">
          <Typography variant="body2Medium">{t('uploadPdf.noFile')}</Typography>
        </div>
      )}
    </div>
  );
};

export default FileUploadSection;
